import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=1970e70c&scoped=true"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=1970e70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970e70c",
  null
  
)

export default component.exports